<template>
  <div>
    <Master pageTitle="customer.customer_sale-channel-management">
      <template #search>
        <ExpansionPanel :isUpDown="false">
          <template #header>
            <div class="searchAreaStyle d-flex align-center mr-5">
              <span class="titleStyle font-weight-bold pl-10">
                {{ $t('common.common_sale-channel') }}
              </span>
            </div>
            <v-checkbox
              v-model="filter.isEnabled"
              :label="$t('common.common_hide-unused-customer-category')"
            />
          </template>
        </ExpansionPanel>
      </template>
      <template #button>
        <NormalButton
          text="customer.customer_sale-channel-registration"
          height="32px"
          width="110px"
          class="text-right"
          @click="dialogInfo.register = true"
        />
        <MasterCustomerCategoryDialog
          v-model="dialogInfo.register"
          @success="registerSuccess()"
        />
      </template>
      <template #list>
        <div class="customerCategoryTable">
          <v-data-table
            :headers="headers"
            :items="getFilterCustomerCategoryList"
            :item-key="itemKey"
            :items-per-page="-1"
            hide-default-footer
            :no-data-text="$t('common.common_not-register')"
            class="rounded-lg"
          >
            <template #isEnabled="{ item }">
              {{ getCustomerCategoryStatus(item.isEnabled) }}
            </template>
            <template #[`item.name`]="{ item }">
              <div class="font-weight-bold">{{ item.name || '-' }}</div>
            </template>
            <template #[`item.sortNumber`]="{ item }">
              <div class="text-center">
                {{ item.sortNumber || '-' }}
              </div>
            </template>
            <template #[`item.edit`]="{ item }">
              <v-layout>
                <WhiteButton
                  text="common.common_edit"
                  height="32px"
                  width="48px"
                  class="mx-2"
                  @click="edit(item)"
                />
                <div v-if="item.isEnabled" class="mx-auto">
                  <NormalButton
                    :text="$t('表示')"
                    class="mr-2"
                    btnClass="pa-2"
                    height="32px"
                    @click="editIsEnabledToFalse(item)"
                  />
                </div>
                <div v-else class="mx-auto">
                  <NormalButton
                    :text="$t('非表示')"
                    class="mr-2"
                    btnClass="pa-2"
                    height="32px"
                    color="white"
                    textColor="thinText--text"
                    @click="editIsEnabledToTrue(item)"
                  />
                </div>
              </v-layout>
            </template>
          </v-data-table>
        </div>
      </template>
    </Master>
    <MasterCustomerCategoryDialog
      v-model="dialogInfo.edit"
      :customerCategoryData="customerCategoryData"
      :editMode="true"
      @success="editSuccess()"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { Master } from '@/components/layouts'
import { MasterCustomerCategoryDialog } from '@/components/layouts/Dialogs'
import { ExpansionPanel, NormalButton, WhiteButton } from '@/components/items'
import { i18n } from '@/main'

export default {
  components: {
    ExpansionPanel,
    Master,
    MasterCustomerCategoryDialog,
    NormalButton,
    WhiteButton
  },
  data: () => {
    return {
      customerCategoryData: {},
      dialogInfo: {
        register: false,
        edit: false
      },
      headers: [
        {
          text: 'id',
          value: 'customerCategoryId',
          sortable: true,
          width: '2%'
        },
        {
          text: i18n.tc('sale.sale_status'),
          value: 'isEnabled',
          sortable: true,
          width: '7%',
          align: 'center'
        },
        {
          text: i18n.tc('customer.customer_sale-channel-name'),
          value: 'name',
          sortable: true,
          width: '80%'
        },
        {
          text: i18n.tc('common.input_sort-number'),
          value: 'sortNumber',
          sortable: true,
          width: '9%'
        },
        {
          text: i18n.tc('payment.payment_operation'),
          value: 'edit',
          sortable: false,
          width: '9%'
        }
      ],
      itemKey: 'customerCategoryId',
      editMode: false,
      filter: {
        isEnabled: true
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions('Common', [
      'getCustomerCategoryListFromApi',
      'editCustomerCategory'
    ]),
    ...mapGetters('Common', ['getCustomerCategoryFromState']),

    async init() {
      await this.getCustomerCategoryListFromApi()
    },
    getCustomerStatus(isEnabled) {
      if (isEnabled == null) {
        return this.$t('common.common_normal')
      }
      const customerCategoryStatus = isEnabled
        ? this.$t('common.common_normal')
        : this.$t('common.common_hide')
      return customerCategoryStatus
    },
    edit(customerCategory) {
      this.customerCategoryData = { ...customerCategory }
      this.dialogInfo.edit = true
    },
    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    },
    async editIsEnabledToFalse(item) {
      await this.editCustomerCategory({
        id: item.customerCategoryId,
        name: item.name,
        sortNumber: item.sortNumber,
        isEnabled: false
      })
      item.isEnabled = 0
    },
    async editIsEnabledToTrue(item) {
      await this.editCustomerCategory({
        id: item.customerCategoryId,
        name: item.name,
        sortNumber: item.sortNumber,
        isEnabled: true
      })
      item.isEnabled = 1
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    getFilterCustomerCategoryList() {
      let customerCategoryList = this.getCustomerCategoryFromState()

      // 非表示フラグ
      const isEnabledFlg = this.filter.isEnabled
      if (isEnabledFlg) {
        customerCategoryList = customerCategoryList.filter((customerCategory) => {
            return customerCategory.isEnabled === 1
          }
        )
      }

      return customerCategoryList
    }
  }
}
</script>
<style scoped lang="scss">
.customerCategoryTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border: 1px solid #d8d8d8;
    border-right: 0;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }
  ::v-deep .v-data-table thead th:first-child {
    border-radius: 10px 0 0 0;
  }
  ::v-deep .v-data-table thead th:last-child {
    border-radius: 0 10px 0 0;
  }
  ::v-deep .v-data-table tr:last-child td:first-child {
    border-radius: 0 0 0 10px;
  }
  ::v-deep .v-data-table tr:last-child td:last-child {
    border-radius: 0 0 10px 0;
  }
}
.searchAreaStyle {
  height: 70px;
  .titleStyle {
    font-size: 18px;
  }
}
</style>
